import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import LoginForm from "./components/LoginForm";
import Layout from "./components/Layout";
import Logout from "./components/Logout";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import Management from "./pages/Management";


export default function App() {
  return (
    <Routes>
      {/* Redirect root → /login */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Public routes */}
      <Route path="/login" element={<LoginForm />} />
      <Route path="/logout" element={<Logout />} />
      {/* Protected routes with Layout wrapper */}
      <Route element={<Layout />}>
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={["Admin", "Supervisor", "Cleaner"]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["Admin"]}>
              <Management />
            </ProtectedRoute>
          }
        />
      </Route>

      {/* Fallback routes */}
      <Route path="/unauthorized" element={<p>Access Denied</p>} />
      <Route path="*" element={<p>Page Not Found</p>} />
    </Routes>
  );
}
